import { useCallback, useEffect, useState } from "react";
import * as finService from "../../services/finService";

// Active rows of Finance masters as dropdown options: { "legal-entities": [{ label, value, code }], ... }.
// `code` is kept because ids are encrypted afresh in every response: an edit form finds
// the row's current choice by code (optionByCode), not by comparing ids.
// `reloadKey` refetches (e.g. after a business unit was added on the same screen).
export default function useFinOptions(keys, reloadKey = 0) {
  const [state, setState] = useState({});
  const wanted = keys.join(",");

  const load = useCallback(async () => {
    const entries = await Promise.all(
      wanted.split(",").filter(Boolean).map(async (key) => {
        try {
          const res = await finService.listMaster(key, { status: "ACTIVE" });
          const rows = Array.isArray(res?.data) ? res.data : [];
          return [key, rows.map((r) => ({ label: r.code ? `${r.code} – ${r.name}` : r.name, value: r.id, code: r.code, row: r }))];
        } catch {
          return [key, []];
        }
      })
    );
    setState(Object.fromEntries(entries));
  }, [wanted]);

  useEffect(() => {
    load();
  }, [load, reloadKey]);

  return state;
}

// The option whose code matches (null when the list has not loaded or the row is gone).
export const optionByCode = (options, code) => (code ? (options || []).find((o) => o.code === code)?.value ?? null : null);
